﻿import { IEmailFlagGroup } from './email-flag-group';

export interface IEmailFlag {
    id: number;
    key: string;
    name: string;
    groupId: number;
    sortOrder: number;
    group: IEmailFlagGroup;
}
